import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa66929e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "20px"
  }
}, "扫码成功", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_icon, {
    style: {
      "margin-right": "20px"
    },
    color: "#67C23A",
    size: 120
  }, {
    default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
    _: 1
  }), _hoisted_2]);
}